/**
 * @deprecated
 * TODO: #594 Use axios module
 */
export const LOAD_STATE = {
    LOADING: 'loading',
    FAIL: 'fail',
    SUCCESS: 'success',
    CANCELED: 'canceled',
};

/**
 * @deprecated
 * TODO: #594 Use axios module
 */
const REDUX_CONSTANTS = {
    LOAD_STATE,
};

export default REDUX_CONSTANTS;
